import { Grid } from '@mui/material';
import { useMyIntl } from 'my-intl';

import { styles } from './constants';

function Title() {
  const { translateMessage } = useMyIntl();
  const isWidthLessThen600 = window.innerWidth < 600;
  const fontSize = isWidthLessThen600 ? '3rem' : '3.5rem';

  return (
    <Grid container position={'relative'} marginBottom={'4rem'}>
      <Grid>
        <img src="images/main-image.jpg" alt={translateMessage('title.name')} width={'100%'} />
      </Grid>
      <Grid
        color={styles.title.color}
        fontFamily={styles.title.font.secondary}
        fontSize={fontSize}
        position={'absolute'}
        top={'50%'}
        left={'3.5%'}
        maxWidth={'36rem'}
        textTransform={'uppercase'}
        sx={{
          textShadow: 'rgba(0, 0, 0, 0.75) 7px 7px 10px',
        }}
      >
        {translateMessage('title.name')}
      </Grid>
    </Grid>
  );
}

export default Title;
